import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3100/review";
};

export const loadReviewTag = id => {
  const url = `${baseURL()}/loadReviewKey/${id}`;

  return axios.post(url);
};

export const loadRestaurantReview = (restID, reviewID, params) => {
  const url = `${baseURL()}/loadRestReview/${restID}/${
    reviewID !== null ? reviewID : ""
  }`;

  return axios.post(url, params);
};

export const reviewRestaurantWithImage = (rid, orderID, params) => {
  const url = `${baseURL()}/restReview/${rid}/${orderID}`;
  return axios.post(url, params);
};

export const likedRestaurantReview = reviewID => {
  const url = `${baseURL()}/likeReview/${reviewID}`;
  return axios.post(url);
};
